import React from 'react';
import { CircularProgress, withStyles } from '@material-ui/core';
import RoutesGrid from './RoutesGrid';
import ShipmentsGrid from './ShipmentsGrid';
import { styles } from '../styles';

const GRID_TYPES = {
  routes: 'routes',
  shipments: 'shipments'
} as const;

interface GridsContentProps {
  classes: Record<string, string>;
  routes: any[];
  filteredShipments: any[];
  gridStatus: string | null;
  loading: boolean;
  error: string | null;
  maximizedGridType: string | null;
  onRoutesSelected: (routes: any[]) => void;
  onShipmentDoubleClick: (event: any) => void;
  onToggleGridMaximize: (gridType: string | null) => void;
}

const GridsContent: React.FC<GridsContentProps> = ({
  classes,
  routes,
  filteredShipments,
  gridStatus,
  loading,
  error,
  maximizedGridType,
  onRoutesSelected,
  onShipmentDoubleClick,
  onToggleGridMaximize
}) => {
  const createMaximizeHandler = (gridType: string) => (isMaximized: boolean) =>
    onToggleGridMaximize(isMaximized ? gridType : null);

  if (loading) {
    return (
      <div className={classes.loadingContainer}>
        <CircularProgress size={40} />
      </div>
    );
  }

  if (error) {
    return (
      <div className={classes.errorContainer}>
        {error}
      </div>
    );
  }

  return (
    <div
      className={`${classes.gridsContainer} ${
        maximizedGridType ? classes.gridsContainerMaximized : ''
      }`}
    >
      <RoutesGrid
        data={routes}
        onRowsSelected={onRoutesSelected}
        onToggleGridMaximize={createMaximizeHandler(GRID_TYPES.routes)}
        isVisible={!maximizedGridType || maximizedGridType === GRID_TYPES.routes}
        isMaximized={maximizedGridType === GRID_TYPES.routes}
        gridStatus={gridStatus}
      />
      <ShipmentsGrid
        data={filteredShipments}
        onRowDoubleClicked={onShipmentDoubleClick}
        onToggleGridMaximize={createMaximizeHandler(GRID_TYPES.shipments)}
        isVisible={!maximizedGridType || maximizedGridType === GRID_TYPES.shipments}
        isMaximized={maximizedGridType === GRID_TYPES.shipments}
        gridStatus={gridStatus}
      />
    </div>
  );
};

export default withStyles(styles)(GridsContent);
